<template>
  <dd-card class="slim-card">
      <div class="flex-row justify-content-between">
          <div id="sorting-inputs" class="flex-row align-items-center flex-stretch gap-md">
              <dd-input
                  placeholder="Zoeken in verzendadres"
                  class="search-input"
                  v-model="filter.sender"
                  @input="handleInput"
                  type="search"
                  autocomplete="off"
                  spellcheck="false"
                  :allow-clear="true"
                  style="min-width: 160px"
              />
              <dd-input
                  placeholder="Zoeken in onderwerp"
                  class="search-input"
                  v-model="filter.subject"
                  @input="handleInput"
                  type="search"
                  autocomplete="off"
                  spellcheck="false"
                  :allow-clear="true"
                  style="min-width: 160px"
              />
              <dd-date-range-picker
                v-model="filter.dateRange"
                @input="handleInput"
                style="flex: 1"
              />
            <dd-icon-button
                icon="mdi mdi-close"
                title="verwijder alle filters"
                size="xl"
                @click="clearFilter"
            ></dd-icon-button>

            <dd-button
                v-if="selectedAccount && !selectedAccount.isMailbox"
                small
                icon="mdi mdi-refresh"
                title="Synchroniseer"
                size="xl"
                style="height: 30px; width: 160px; justify-content: center;"
                @click="syncMailAccount"
              >
                Synchroniseer
              </dd-button>
          </div>
      </div>
  </dd-card>
</template>

<script>
import EmailAccountApi from '~/api/email_account.js';
import {mapActions, mapGetters} from "vuex";


export default {
  name: "InboxSortingComponent.vue",
  methods: {
    ...mapActions('email', [
        'setProcessedState',
        'loadEmails',
        'clearFilter'
    ]),
    handleInput() {
      this.debounce(this.loadEmails)();
    },
    debounce(func, timeout = 800) {
      return () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(func, timeout);
      };
    },
    async syncMailAccount(){
      const accountId = this.selectedAccount.id;
      const response = await EmailAccountApi.sync(accountId);
      this.$notification[response.success ? 'success' : 'error']({
        description: response.message
      })
    }
  },
  computed: {
    ...mapGetters("email", [
      "selectedAccount",
      "accountState",
      "filter"
    ])    
  }
}

</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.slim-card{
  padding-top: $spacing-md !important;
  padding-bottom: $spacing-md !important;
}
.search-input{
  flex: 0.5;
}
</style>

<style lang="scss">
@import "~@/_default.scss";
#sorting-inputs{
  .search-input input:not(.hidden-input),
  .ant-calendar-picker-input {
      width: 100% !important;
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      height: $spacing-xl !important;
      min-height: $spacing-xl !important;
  }
  .ant-calendar-range-picker-separator {
    line-height: 200%;
  }
}
</style>
